import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/skeleton/style";
import _Skeleton from "vant/es/skeleton";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/lazyload/style";
import _Lazyload from "vant/es/lazyload";
import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/image/style";
import _Image from "vant/es/image";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/cell-group/style";
import _CellGroup from "vant/es/cell-group";
import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import "vant/es/form/style";
import _Form from "vant/es/form";
import "vant/es/checkbox/style";
import _Checkbox from "vant/es/checkbox";
import "vant/es/divider/style";
import _Divider from "vant/es/divider";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import Vue from 'vue';
// 在这里引入你所需的组件

_Toast.setDefaultOptions({
  zIndex: 9999
});

// 链式全局注册组件
Vue.use(_Button).use(_Skeleton).use(_Loading).use(_Dialog).use(_List).use(_Toast).use(_Popup).use(_Lazyload).use(_Overlay).use(_Icon).use(_Image).use(_SwipeItem).use(_Swipe).use(_PullRefresh).use(_Cell).use(_ActionSheet).use(_Tab).use(_Tabs).use(_Field).use(_CellGroup).use(_Notify).use(_Form).use(_Checkbox).use(_Divider);